import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { CardModule } from 'primeng/card';
import { DividerModule } from 'primeng/divider';
import { Concrete, Device, Measurement } from '@cosmos/shared';

/**
 * Two-column shell + info card shared by every measurement detail state
 * (started, awaiting-start, never-started). The left column projects the
 * quick-switch panel via `<ng-content select="[quickSwitch]">`; the card
 * body and its footer buttons are projected via `<ng-content select="[cardFooter]">`,
 * since each state exposes a different set of actions.
 */
@Component({
  selector: 'cosmos-measurement-info-card',
  templateUrl: './measurement-info-card.component.html',
  imports: [TranslatePipe, DatePipe, CardModule, DividerModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MeasurementInfoCardComponent {
  readonly measurement = input.required<Measurement>();
  readonly device = input<Device | null>(null);
  readonly concrete = input<Concrete | null>(null);
  /** Pre-composed, already-translated subtitle string (e.g. "Temperature - Ongoing"). */
  readonly cardSubtitle = input<string>('');
}
